module.exports = __webpack_public_path__ + "img/path.a6231578.png";